exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input[data-v-7ca39f93]{position:relative}.input__popup[data-v-7ca39f93]{position:absolute;bottom:calc(100% + 8px)}.input__text[data-v-7ca39f93]{width:100%}", ""]);

// exports
